import React, { useEffect } from 'react';
import { createBrowserRouter, Outlet, RouterProvider, ScrollRestoration } from 'react-router';

import { privateRoutes, publicRoutes } from 'routes';
import { useAuth, usePreloader } from 'hooks';
import { ErrorPage } from 'pages';
import { Preloader } from 'components/ui';

const router = createBrowserRouter([
  {
    errorElement: <ErrorPage />,
    hydrateFallbackElement: <Preloader active />,
    element: (
      <>
        <Outlet />
        <ScrollRestoration />
      </>
    ),
    children: [
      ...publicRoutes,
      ...privateRoutes,
    ],
  },
]);

const AppProvider = () => {
  const auth = useAuth();
  const preloader = usePreloader();

  useEffect(() => {
    preloader.toggle(!auth.initialized);
  }, [auth.initialized, preloader]);

  useEffect(() => {
    const unsubscribe = router.subscribe((state) => {
      preloader.toggle(state.navigation.state === 'loading');
    });

    return () => {
      unsubscribe();
    };
  }, [preloader]);

  return auth.initialized && <RouterProvider router={router} />;
};

const App = {
  Provider: AppProvider,
};

export default App;
